<template lang="pug">
 .widget(
   :draggable='is_draggable'
   @click='edit_widget(widget)'
   @mouseover='hover_active = true'
   @mouseleave='hover_active = false'
   @dragend='drag_end'
   @dragenter='drag_enter'
   @dragover='drag_over'
   @dragleave='drag_leave'
   @dragstart='drag_start'
   @drop='drop'
   :class='{ "widget-overlay": show_header, "drop-zone-bottom": indicate_drop_bottom }')

  widget_header(
    :show_header='show_header'
    :is_offset='offset_header'
    :widget='widget'
    @edit_widget='edit_widget'
    @delete_widget='delete_widget')

  component(
    :is='`${widget.widget.name}_widget`'
    :widget='widget'
    :brand='brand'
    :retailer='retailer'
    :landing_page='landing_page'
    :show_inline_placeholders='show_inline_placeholders'
    :api_base_path='api_base_path'
    :selected_share_id='selected_share_id')
  .debug(v-if='debug_mode')
    | Index: {{widget.index}}
</template>

<script>
  // available widgets
  import widget_header from './widget_header.vue'

  // @vue/component
  export default {
    name: 'widget',
    components: {
      widget_header
    },
    props: {
      widget: {
        type: Object,
        required: true
      },
      brand: {
        type: Object,
        required: false,
        default: () => ({})
      },
      retailer: {
        type: Object,
        required: false,
        default: () => ({})
      },
      landing_page: {
        type: Object,
        required: true
      },
      share_setting: {
        type: Object,
        required: false,
        default: () => ({})
      },
      column_count: {
        type: Number,
        required: false,
        default: 12
      },
      clear: {
        type: Boolean,
        required: false,
        default: false
      },
      background_color: {
        type: String,
        required: false,
        default: ''
      },
      font_style: {
        type: String,
        required: false,
        default: ''
      },
      font_size: {
        type: String,
        required: false,
        default: ''
      },
      is_edit: {
        type: Boolean,
        required: false,
        default: false
      },
      show_inline_placeholders: {
        type: Boolean,
        required: false,
        default: false
      },
      api_base_path: {
        type: String,
        required: true
      },
      debug_mode: {
        type: Boolean,
        required: false,
        default: false
      },
      selected_share_id: {
        type: String,
        required: false
      }
    },
    data() {
      return {
        indicate_drop_bottom: false,
        hover_active: false
      }
    },
    computed: {
      is_draggable() {
        return this.widget.widget.name !== 'header' && this.widget.widget.name !== 'footer'
      },
      show_header() {
        return this.is_draggable && this.hover_active
      },
      offset_header() {
        return this.widget.widget.name === 'divider'
      }
    },
    methods: {
      show_drop_zone(event) {
        const initial_index = this.$parent.initial_drag_index
        const widget_index = this.$el.getAttribute('widget_index')
        if ((this.is_draggable && (widget_index != initial_index && widget_index != initial_index-1)) || this.widget.widget.name === 'header') {
          event.preventDefault()
          this.indicate_drop_bottom = true
        }
      },
      edit_widget(landing_page_widget) {
        if (landing_page_widget.widget && !['header','footer'].includes(landing_page_widget.widget.name)) {
          this.$emit('edit_widget', landing_page_widget)
        }
      },
      delete_widget(landing_page_widget) {
        this.$emit('delete_widget', landing_page_widget)
      },
      drag_end() {
        this.$emit('initial_drag_index', null)
      },
      drag_over(event) {
        this.show_drop_zone(event)
      },
      drag_start(event) {
        this.$emit('initial_drag_index', this.$el.getAttribute('widget_index'))
        event.dataTransfer.setData('widget_index', this.$el.getAttribute('widget_index'))
      },
      drag_leave() {
        this.indicate_drop_bottom = false
      },
      drag_enter(event) {
        this.show_drop_zone(event)
      },
      drop(event) {
        if (event.dataTransfer.getData('widget_index') && event.dataTransfer.getData('widget_index') >= 0) {
          this.$emit('move_widget', { event: event, element: this.$el })
        } else if (event.dataTransfer.getData('widget_id') && event.dataTransfer.getData('widget_id') >= 1) {
          this.$emit('add_widget', { event: event, element: this.$el })
        }
        this.$emit('initial_drag_index', null)
        this.indicate_drop_bottom = false
      }
    }
  }
</script>

<style lang="scss">
  .error {
    i {
      position: absolute;
      top: 0px;
      right: 10px;
      color: red;
      font-size: 2em;
    }
  }
</style>

<style lang="scss" scoped>
  @import '../../styles/variables_and_mixins';
  .widget {
    [class*="_widget"]:not([class*="header"]):not([class*="footer"]) {
      &:hover {
        cursor: pointer;
      }
    }
    position: relative;
    z-index: 10;
    &-overlay {
      &:before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        background: transparent;
        @include transition-property(background);
        @include transition-duration(0.5s);
        z-index: 11;
      }
      &:hover {
        &:before {
          background: rgba(0,0,0,0.2);
        }
      }
    }
    &.drop-zone-bottom::after {
      content: 'Drop widget here!';
      display: table;
      clear: both;
      width: 100%;
      background-color: #96bdc5;
      color: white;
      padding: 30px;
      text-align: center;
      margin: 10px 0;
    }
  }

  .debug {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9999999999;
    background-color: #E73C7E;
    color: white;
    padding: 10px;
  }
</style>
